import React from "react";

function Dashboard() {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%', backgroundColor: '#f4f7fc' }}>
      <h1 className="fw-bold " style={{ color: '#5A607F', fontSize: '55px' }}>Coming Soon...</h1>
    </div >
  );
}

export default Dashboard;
